import { useTranslation } from 'react-i18next'

export default function LoadMoreSection({
  hasMore,
  loadingMore,
  onLoadMore,
  dataLength,
  totalCount
}) {
  const { t } = useTranslation()

  if (!hasMore && dataLength === 0) {
    return null;
  }

  return (
    <div className="mt-6 flex flex-col items-center">
      {/* Results count */}
      <div className="text-sm text-gray-500 mb-4">
        {t('loadMore.showingRecords', { current: dataLength, total: totalCount })}
      </div>

      {/* Load more button */}
      {hasMore && (
        <button
          onClick={onLoadMore}
          disabled={loadingMore}
          className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loadingMore ? (
            <>
              <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600 mr-2"></div>
              {t('loadMore.loading')}
            </>
          ) : (
            t('loadMore.button')
          )}
        </button>
      )}

      {/* No more results message */}
      {!hasMore && dataLength > 0 && (
        <div className="text-sm text-gray-500">
          {t('loadMore.allLoaded')}
        </div>
      )}
    </div>
  );
}
